export function identity<T>(x: T) {
  return x;
}
